import { render, staticRenderFns } from "./file-info.vue?vue&type=template&id=086c39e6&scoped=true"
import script from "./file-info.vue?vue&type=script&lang=js"
export * from "./file-info.vue?vue&type=script&lang=js"
import style0 from "./file-info.vue?vue&type=style&index=0&id=086c39e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c39e6",
  null
  
)

export default component.exports